import { publicURL } from '../../../helpers/environment';

export const bon = {
  agencyCode: '16',
  name: 'Texas Board of Nursing',
  shortName: 'Board of Nursing',
  slug: 'bon',
  logo: publicURL('agency-logos/board-of-nursing.png')
};
